import './icons'

import Accordion from './accordion'
import AsyncPage from './async-page'
import SectionFilter from './section-filter'
import ButtonFollow from './button-follow'

import ButtonScroll from './button-scroll'
import Carousel from './carousel'

import Modals from './modals'
import Search from './search'
import VueComponents from './vue-component'
import GLightbox from 'glightbox'

import '@/scss/base.scss'

class APP {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[Cinefil] Base online')

      this.initPage()
      this.initCarousels()
      this.initAsyncPage()
    })
  }

  initPage() {
    this.vueComponents = new VueComponents()
    this.modals = new Modals()
    this.sectionFilter = new SectionFilter()
    this.accordion = new Accordion()
    this.buttonFollow = new ButtonFollow()
    this.buttonScroll = new ButtonScroll()
    this.search = new Search()
  }

  initAsyncPage() {
    this.asyncPages = []

    const elements = document.querySelectorAll('.is-async-page.is-autoload')
    if (!elements.length) return

    elements.forEach((element) => {
      this.asyncPages.push(new AsyncPage(element))
    })
  }

  initCarousels() {
    this.carousels = {
      featured: new Carousel('.swiper.is-featured', {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.3,
          },
          1024: {
            slidesPerView: 1.7,
          },
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        pagination: {
          el: '.swiper-pagination',
          // dynamicBullets: true,
          // dynamicMainBullets: 3,
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 48,
        speed: 500,
        on: {
          init(swiper) {
            const controlPlay = swiper.el.querySelector('.is-play-pause')
            if (!controlPlay) return

            const [pauseIcon, playIcon] = controlPlay.querySelectorAll('.icon')
            let isManuallyPaused = false

            const setAutoplayUiState = (paused) => {
              swiper.el.classList.toggle('is-paused', paused)

              if (paused) {
                pauseIcon?.classList.add('is-hidden')
                playIcon?.classList.remove('is-hidden')
                controlPlay.setAttribute('aria-label', 'Pornește carusel')
                controlPlay.setAttribute('aria-pressed', 'true')
              } else {
                pauseIcon?.classList.remove('is-hidden')
                playIcon?.classList.add('is-hidden')
                controlPlay.setAttribute('aria-label', 'Pauză carusel')
                controlPlay.setAttribute('aria-pressed', 'false')
              }
            }

            setAutoplayUiState(false)

            controlPlay.addEventListener('click', () => {
              if (isManuallyPaused) {
                swiper.autoplay.resume()
                isManuallyPaused = false
              } else {
                swiper.autoplay.pause()
                isManuallyPaused = true
              }

              setAutoplayUiState(isManuallyPaused)
            })
          },
        },
      }),

      cinemas: new Carousel('.swiper.is-cinemas', {
        freeMode: true,
        edgeSwipeDetection: 'prevent',
        centerInsufficientSlides: 'true',
        slidesPerView: 'auto',
        spaceBetween: 12,
      }),

      lists: new Carousel('.swiper.is-list.is-default', {
        freeMode: true,
        edgeSwipeDetection: 'prevent',
        slidesPerView: 1.05,
        spaceBetween: 12,
        breakpoints: {
          768: { slidesPerView: 2.3 },
          1024: { slidesPerView: 3.3, spaceBetween: 24 },
          1366: { slidesPerView: 4.3, spaceBetween: 24 },
        },
      }),

      listCinemas: new Carousel('.swiper.is-list.is-related-cinemas', {
        freeMode: true,
        edgeSwipeDetection: 'prevent',
        slidesPerView: 1.05,
        spaceBetween: 12,
        breakpoints: {
          768: { slidesPerView: 2.2 },
          1024: { slidesPerView: 2.5, spaceBetween: 24 },
          1366: { slidesPerView: 3, spaceBetween: 24 },
        },
      }),

      cinemaGallery: new Carousel('.swiper.is-cinema-gallery', {
        freeMode: true,
        edgeSwipeDetection: 'prevent',
        slidesPerView: 1.3,
        spaceBetween: 16,
        breakpoints: {
          768: { slidesPerView: 2.3 },
          1024: { slidesPerView: 3.3 },
          1366: { slidesPerView: 5.3 },
        },
      }),

      gallery: new Carousel('.swiper.is-gallery', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
      }),

      header: new Carousel('.swiper.is-performance', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        thumbs: {
          swiper: {
            el: '.swiper.is-performance-nav',
            centerInsufficientSlides: 'true',
            edgeSwipeDetection: 'prevent',
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 8,
          },
        },
      }),
    }

    const lightboxHTML = `
        <div id="glightbox-body" class="glightbox-container">
          <div class="gloader visible"></div>
          <div class="goverlay"></div>
          <div class="gcontainer">
            <div id="glightbox-slider" class="gslider"></div>
            <button class="gnext gbtn button is-medium is-square is-grey-6 is-rounded" tabindex="0" aria-label="Următorul"><span class="icon is-icon-7"><iconify-icon icon="radix-icons:chevron-right" noobserver></iconify-icon></span></button>
            <button class="gprev gbtn button is-medium is-square is-grey-6 is-rounded" tabindex="1" aria-label="Precedentul"><span class="icon is-icon-7"><iconify-icon icon="radix-icons:chevron-left" noobserver></iconify-icon></span></button>
            <button class="gclose gbtn button is-medium is-square is-grey-6 is-rounded" tabindex="2" aria-label="Închide"><span class="icon is-icon-4"><iconify-icon icon="radix-icons:cross-1" noobserver></iconify-icon></span></button>
          </div>
        </div>`

    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      lightboxHTML,
    })
  }
}

export default new APP()
